// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BtjA","productName":"Table_productName__3B0dI"};